import React, { useState } from 'react';
import { RadioInput } from 'src/components/InputRadio';
import PaymentType from 'src/model/PaymentType';

interface PaymentTypeProps {
  onSelectType: (type: PaymentType) => void;
  totalAmount: number;
  minimoParcelamento?: number;
  voucherAvailable: boolean;
  voucherMessage?: string;
}

export const PaymentTypeUI: React.FC<PaymentTypeProps> = ({
  onSelectType,
  totalAmount,
  minimoParcelamento = 50,
  voucherAvailable,
  voucherMessage,
}) => {
  const [selected, setSelected] = useState<PaymentType | null>(null);

  const select = (t: PaymentType) => {
    if (t === PaymentType.VOUCHER && !voucherAvailable) return;
    setSelected(t);
    onSelectType(t);
  };

  const optionClass = (active: boolean, disabled = false) =>
    `min-h-[72px] rounded-xl border px-3 py-3 text-left transition-all ${
      disabled
        ? 'cursor-not-allowed border-gray-200 bg-gray-100 text-gray-400'
        : active
          ? 'cursor-pointer border-red-500 bg-red-50 ring-2 ring-red-100'
          : 'cursor-pointer border-gray-200 bg-white hover:border-red-300 hover:shadow-sm'
    }`;

  return (
    <div>
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <label className={optionClass(selected === PaymentType.CREDIT_CARD)}>
          <RadioInput
            name="paymentType"
            label="Cartão de crédito"
            value="CARD"
            onChange={() => select(PaymentType.CREDIT_CARD)}
          />
        </label>
        <label className={optionClass(selected === PaymentType.PIX)}>
          <RadioInput
            name="paymentType"
            label="PIX"
            value="PIX"
            onChange={() => select(PaymentType.PIX)}
          />
        </label>
        <label className={optionClass(selected === PaymentType.BOLETO)}>
          <RadioInput
            name="paymentType"
            label="Boleto"
            value="BOLETO"
            onChange={() => select(PaymentType.BOLETO)}
          />
        </label>
        <label
          className={optionClass(
            selected === PaymentType.VOUCHER,
            !voucherAvailable
          )}
          title={!voucherAvailable ? voucherMessage : undefined}
        >
          <RadioInput
            name="paymentType"
            label="Voucher"
            value="VOUCHER"
            onChange={() => select(PaymentType.VOUCHER)}
          />
          <span className="mt-1 block pl-6 text-xs leading-4">
            Pagamento presencial
          </span>
        </label>
      </div>
      {!voucherAvailable && voucherMessage && (
        <p className="mt-3 rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-800">
          {voucherMessage}
        </p>
      )}
    </div>
  );
};
